import { Injectable, Injector } from '@angular/core';

import { Utilities_FrontendFlowService } from './Utilities.frontend.flow.index';


import { $frontendTypes } from './Totes.frontend.types'

@Injectable({ providedIn: 'root' })
export class Totes_FrontendFlowService {

  constructor(
    public Utilities: Utilities_FrontendFlowService,
    private injector: Injector
  ) {
  }

  public Totes: Totes_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
